import { render, staticRenderFns } from "./NotificationBox.vue?vue&type=template&id=cc0e029e&scoped=true"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"
import style0 from "./NotificationBox.vue?vue&type=style&index=0&id=cc0e029e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0e029e",
  null
  
)

export default component.exports